import React, { FC, memo } from 'react';
import styled from 'styled-components/native';
import Colors from 'theme/colors';
import Fonts from 'theme/fonts';
import PrimaryButton from '../buttons/PrimaryButton';
import SecondaryButton from '../buttons/SecondaryButton';

interface Props {
  correctNumber: number;
  totalNumber: number;
  onReset: () => void;
  onSubmit: () => void;
}

const Container = styled.View`
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  margin-bottom: 24px;
  padding: 16px 12px;
  background-color: ${Colors.WHITE};
  border-top-width: 1px;
  border-top-color: ${Colors.CARD_BORDER};
  border-radius: 12px;
`;

const FooterView = styled.View`
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 4px;
`;

const EmptyView = styled.View`
  width: 12px;
`;

const ResultText = styled(Fonts.Bold)`
  width: 100%;
  font-size: 16px;
  text-align: center;
  color: ${Colors.SUCCESS};
  padding-top: 4px;
  padding-bottom: 12px;
`;

const Hint = styled(Fonts.Normal)`
  width: 100%;
  font-size: 13px;
  text-align: center;
  color: ${Colors.MUTED_TEXT};
  padding-bottom: 12px;
`;

const Footer: FC<Props> = ({ correctNumber, totalNumber, onReset, onSubmit }) => {
  const hasScore = correctNumber >= 0;
  return (
    <Container>
      {hasScore ? (
        <ResultText>{`Kết quả: ${correctNumber} / ${totalNumber} câu đúng`}</ResultText>
      ) : (
        <Hint>Chọn đáp án cho các câu, rồi bấm Nộp bài để chấm điểm.</Hint>
      )}
      <FooterView>
        <SecondaryButton title="Làm lại" onPress={() => onReset()} />
        <EmptyView />
        <PrimaryButton title="Nộp bài" onPress={() => onSubmit()} />
      </FooterView>
    </Container>
  );
};

export default memo(Footer);
